import { render, staticRenderFns } from "./PhysicalStlmt.vue?vue&type=template&id=85838e00"
import script from "./PhysicalStlmt.vue?vue&type=script&lang=js"
export * from "./PhysicalStlmt.vue?vue&type=script&lang=js"
import style0 from "./PhysicalStlmt.vue?vue&type=style&index=0&id=85838e00&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85838e00')) {
      api.createRecord('85838e00', component.options)
    } else {
      api.reload('85838e00', component.options)
    }
    module.hot.accept("./PhysicalStlmt.vue?vue&type=template&id=85838e00", function () {
      api.rerender('85838e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/PhysicalStlmt.vue"
export default component.exports